/**
 * We'll load jQuery and the Bootstrap jQuery plugin which provides support
 * for JavaScript based Bootstrap features such as modals and tabs. This
 * code may be modified to fit the specific needs of your application.
 */

try {
   // window.Popper = require('popper.js').default;
    window.$ = window.jQuery = require('jquery');
    require('bootstrap/js/dist/scrollspy');
    require('bootstrap/js/dist/collapse');
} catch (e) {}

//push Functions:
window.push = require('./push');
import {subscribe,
    initialiseServiceWorker,
    registerServiceWorker,
    updateSubscription,
    urlBase64ToUint8Array
} from "./push";
window.subscribe = subscribe;
window.registerServiceWorker = registerServiceWorker;

//Lightbox
window.lightbox2 = require('lightbox2');


//Sticky-Sidebar
require('theia-sticky-sidebar/dist/ResizeSensor.js')
require('theia-sticky-sidebar/dist/theia-sticky-sidebar.js')

if($("body").width() > 991) {
    $(".toccol, #topicnav").theiaStickySidebar({
        additionalMarginTop: 10
    })
    try {
        $('#toccontent').scrollspy({ target: '#toc' })
    } catch (e) {
        console.log("scrollspy not possible")
    } 
}



/*
$('.htmlcontent img').each(function() { // For each image
if ($(this).attr("data-lightbox-img") != undefined) {
  $(this).wrap('<a href="' + $(this).attr("data-lightbox-img") + '" data-lightbox="' + $(this).attr("alt") + '"></a>'); // And wrap the image
}
})
*/


window.axios = require('axios');
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

//import axiosRetry from 'axios-retry';
//axiosRetry(axios, { retries: 3 });

//419
window.axios.interceptors.response.use(response => response, error => {
    const status = error.response ? error.response.status : null
    if (status == 419) {
          //var originalrequest = error.config
          axios.get('/home/csrf').then(({ data }) => {
            window.axios.defaults.headers.common['X-CSRF-TOKEN'] = data.csrfToken
            //error.config.headers['X-CSRF-TOKEN']=data
            //axios(originalrequest);
          })
        }
    return Promise.reject(error);
    });
//javascript to test if logged and refresh random if not:
$(document).ready(function(){
  if (window.location.search.length <= 0 &&
    document.cookie.includes("nocache=YES") &&
    !document.URL.endsWith("/login") &&
    !document.URL.endsWith("/register") &&
    document.querySelector('meta[http-equiv]').content == "no-store") {
      window.location.search += '&nocache=' + Math.round(Math.random() * 1000000);
  }
  if (!window.ezslots_raw) {$(".flexleftsidebar").css("height","1px");$(".flexrightsidebar").css("height","1px")}
})

//show my ip
/*
if ($('#showmyip').length){
axios.get('/home/ip?myip=' + Math.round(Math.random() * 1000000) ).then((res) => {
  $("#showmyip").text(res.data.ip)})
}
*/
window.ServiceWorkerRegisterTry = false;
$( "body" ).one("mousemove touchstart",function() {
    if (window.startcsrf) {
        return
    }
    window.startcsrf = true
    window.csrfload = axios.get('/home/csrf?r='+encodeURIComponent(document.referrer)).then(({ data }) => {
          var meta = document.createElement('meta');
          meta.httpEquiv = "csrf-token";
          meta.content = data.csrfToken;
          window.userdata = data;
          document.getElementsByTagName('head')[0].appendChild(meta);
          window.axios.defaults.headers.common['X-CSRF-TOKEN'] = data.csrfToken;
            if (data.user != "guest") {
                if (!document.cookie.includes("nocache=YES")) {
                    console.log("set cookie");
                    document.cookie="nocache=YES; expires=" + (new Date(new Date().getTime()+999999999999)) + ";path=/";
                    window.location.search += '&nocache=' + Math.round(Math.random() * 1000000);
                }
            } else {
                if (document.cookie.includes("nocache=YES")) {
                    console.log("remove cookie");
                    document.cookie="nocache=YES; expires=" + (new Date(new Date().getTime()-99999999)) + ";path=/";
                }
            }
          if (!window.ServiceWorkerRegisterTry && 
            window.userdata.vapidPublicKey &&
            (window.location.pathname == "/en/alerts" || window.location.pathname == "/benachrichtigungen")
            ){ //&& document.cookie.includes("cookieCompliancyAccepted=YES")
            registerServiceWorker()
            subscribe()
            window.ServiceWorkerRegisterTry = true
          }
      })
  });

  //$("table").wrap("<div class='table-responsive' style='border:0px;'></div>");
  //$(".htmlcontent pre").addClass("hljs");


// Cookie Compliancy...
/*
function testFirstCookie(){
		if (!document.cookie.includes("cookieCompliancyAccepted=YES")){
		   $("#CookieConsent").show();	// Show warning
	   }
}
if (window.adsbygoogle && document.cookie.indexOf("cookieCompliancyAccepted") == "-1") {
    (adsbygoogle=window.adsbygoogle||[]).pauseAdRequests=1;
}
$(document).ready(function(){
    if (window.adsbygoogle && document.cookie.indexOf("cookieCompliancyAccepted") == "-1") {
        (adsbygoogle=window.adsbygoogle||[]).pauseAdRequests=1;
    }
    $("#cookieButton").click(function(){
        axios.post('/home/consent')
            .then((res) => {
                window.ServiceWorkerRegisterTry = true
                document.cookie="cookieCompliancyAccepted=YES; expires=" + (new Date(new Date().getTime()+999999999999)) + ";path=/";
                if (window.adsbygoogle) {
                    (adsbygoogle = window.adsbygoogle || []).pauseAdRequests=0;
                    try {(adsbygoogle = window.adsbygoogle || []).push({});} catch (e){}
                    try {(adsbygoogle = window.adsbygoogle || []).push({});} catch (e){}
                }
                if (window.userdata.vapidPublicKey) {
                    window.ServiceWorkerRegisterTry = true
                    setTimeout(function(){
                        registerServiceWorker()
                        subscribe()
                    }, 10000);
                }
            })
        $("#CookieConsent").hide(400);
    });
    testFirstCookie();
    if (document.cookie.indexOf("cookieCompliancyAccepted") != "-1" && window.adsbygoogle) {
        try {(adsbygoogle = window.adsbygoogle || []).push({});} catch (e){}
    }

    if ($('.windowback').length){
        $(".windowback").click(function(){ window.history.back();});
    }
});
*/
//... Cookie Compliancy END

$(function() {
  $('.disable-scroll').on('click', function (e) {
    if ($(this).next(".scroll-content").css("overflowY") == "scroll") {
        this.text = "[-]"
        $(this).next(".scroll-content").css("overflowY","initial")
        $(this).next(".scroll-content").css("height","initial")
    } else {
        this.text = "[+]"
        $(this).next(".scroll-content").css("overflowY","scroll")
        $(this).next(".scroll-content").css("height","200px")
    }

  })
  if ($('.windowback').length){
    $(".windowback").click(function(){ window.history.back();});
  }

  if (($(".htmlcontent").length > 0)) { 
    $(window).scroll(function (event) {
        if (window.innerWidth < 992 && $(".edit-hide").css("display") != "none" && $(window).scrollTop() >  $(".htmlcontent").position().top ) {
            $(" #mobiletoccontent ").html("").css("visibility","hidden");
                if (!document.getElementById("editloaded"))  {
                    if ($('#mobiletocbutton').length === 0) {
                        console.log("append Mobile TOC")
                        $('#topicnav').append('<div id="mobiletocbutton" class="edit-hide"><a onclick="$(\'#mobiletoccontent\').prepend($(\'.breadcrumbnav\').clone()).append($(\'#ctoc\').clone().addClass(\'show\')).css(\'visibility\',\'initial\');$(\'#mobiletocbutton\').remove();">|||</a></div><div class="breadcrumb" id="mobiletoccontent"></div>');
                    }    
                }
            }       
        else {
            if ($('#mobiletocbutton').length !== 0) {
                console.log("remove Mobile TOC")
                $('#mobiletocbutton').remove()                
                $('#mobiletoccontent').remove() 
            }  
        }
    });
  }

})